// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleDetail_ColumnRTE_container","rte":"ArticleDetail_ColumnRTE_rte"};